































import {Location} from '@/model/api';
import {SearchResult, SearchResultGroup, SearchResultItem} from '@/model/api/search';
import {debounce} from 'lodash-es';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

interface ItemWithIndex { index: number; item: SearchResultItem; }

@Component
export default class SearchControl extends Vue {
    @Prop({type: Function, required: true})
    public readonly search: (searchQuery: string) => Promise<SearchResult<Location>>;

    @Prop({required: true})
    public readonly value: SearchResultItem | null;

    @Prop({type: String, default: ''})
    public readonly placeholder: string;

    protected searchQuery: string = '';

    protected groups: SearchResultGroup[] = [];

    protected isLoading = false;

    protected focused: boolean = false;

    private readonly lazySearch = debounce(this.updateResults, 1000);
    private preventSearch: boolean = false;
    private current = 0;

    protected get itemsById(): { [id: string]: ItemWithIndex } {
        const items: { [id: string]: ItemWithIndex } = {};
        let index = 0;

        this.groups.forEach(group => {
            group.items.forEach(item => {
                items[item.id] = {index, item};
                index++;
            });
        });

        return items;
    }

    public isEmpty(): boolean {
        return this.value === null;
    }

    public created() {
        if (this.value) {
            this.preventSearch = true; // do not search for this default value
            this.searchQuery = this.value.name;
        }
    }

    public updateResults(): void {
        if (this.preventSearch) {
            this.preventSearch = false;
            return;
        }

        if (this.searchQuery === '') {
            return;
        }

        this.groups = [];
        this.isLoading = true;

        this.search(this.searchQuery)
            .then(result => {
                this.groups = result.groups.filter(group => group.items.length > 0);
                this.current = 0;
                this.$nextTick(() => this.isLoading = false);
            });
    }

    @Watch('searchQuery')
    protected onSearch(): void {
        if (this.searchQuery === '') {
            this.$emit('input', null);
            return;
        }

        this.lazySearch();
    }

    protected selectOption(index: number): void {
        const value = Object.values(this.itemsById).find(item => item.index === index)!.item;
        this.preventSearch = true;
        this.searchQuery = value.name;
        (this.$refs.input as HTMLElement).blur();

        this.$emit('input', value);
    }

    protected up(): void {
        this.current = this.current === 0 ? Object.keys(this.itemsById).length : this.current - 1;
    }

    protected down(): void {
        this.current = this.current === Object.keys(this.itemsById).length ? 0 : this.current + 1;
    }

    protected enter(): void {
        if (this.groups.length === 0) {
            return;
        }

        this.selectOption(this.current);
    }

    protected focus(): void {
        this.focused = true;
    }

    protected blur(): void {
        setTimeout(() => this.focused = false, 200);
    }
}
